import { Box, Heading, Stack, Text } from 'braid-design-system';
import React from 'react';

const Intro = () => (
  <Box
    paddingX="medium"
    paddingTop={['xlarge', 'xxlarge']}
    paddingBottom="medium"
  >
    <Stack space="large" align="center">
      <Heading align="center" level="1">
        Find the right candidate with the right ad
      </Heading>
      <Box paddingX="medium" maxWidth="small">
        <Text size="large">
          No matter what role you&apos;re trying to fill, there&apos;s an option
          to help you attract and engage with candidates.
        </Text>
      </Box>
    </Stack>
  </Box>
);

export default Intro;
